module.exports = __webpack_public_path__ + "img/logo_withe.b36047f3.png";